//—— 閣中五位 ——
//
//  五支產品不是「五種算命服務」，而是五個互不重疊的提問維度。
//  這樣使用者不會猶豫該買哪一支，也才有回頭買第二支的理由：
//
//    白夜     我天生是什麼材料        先天本質    一生一次
//    鏡月     我的人生十二格各是什麼   全面格局    一生一次
//    緋紅     我和他之間怎麼回事      關係        每段感情一次
//    伏爻子   這件事會怎麼發展        單一事件    隨問隨買
//    判官     今年記了我什麼          時間        每年一次
//
//  每支配一位角色而不是只給服務名稱：命理報告的說服力有一半來自「誰在跟你說」，
//  同一段內容用不同語氣寫出來，可信度差很多。persona.tone 就是要餵給
//  engine 的 system prompt，讓 AI 寫出來的口吻穩定地是那個人。
//
//  —— 欄位分兩層 ——
//    展示用（glyph / theme / title / subtitle / badge / image）→ 給 ProductCard
//    後端用（code / reportType / price）→ 對應 order.productCode 與 engines/ 資料夾
//
//  ⚠️ reportType 必須跟 config/product-plans.js 的同名欄位一字不差 ——
//  它是前後端對照報告類型的那把鑰匙。鏡月與緋紅這兩筆曾經寫成
//  ziwei-chart / love-synastry，跟後端的 jingyue-natal / feihong-natal
//  對不上。當時沒有人讀這個欄位所以沒出事，但任何拿它做對照的功能
//  都會在這兩支上默默失效。
//  混在同一份是刻意的：兩邊各留一份一定會不同步。
//
//  圖有兩個尺寸，用途不同，不要互換：
//    image      900×1200 直式，給 ProductCard 的 3:4 封面
//    imageWide  1600×893 橫式，給產品詳情頁的主視覺
//  卡片如果直接吃橫圖，cover 會把左右裁掉六成，人物只剩中間一條。
//
//  theme 在有圖之後只剩兩個作用：圖還沒載完時的底色、以及小方卡的退路，
//  所以挑的是「和那張圖同一個色溫」而不是隨便配。
//
//  price 是暫定值，等定價確認後改這裡一處即可。
//
//  categories 對應頂部分類列的 key（見 constant/menulist 的 CATEGORY_TABS）。
//  分類寫在產品身上而不是另外維護一份「分類 → 產品」的對照表：
//  新增產品時只會漏掉自己這一行，不會出現「產品建了但忘了掛進分類」。
//  「綜合」不必標 —— 它的定義是「全部」，由 getProductsByCategory 直接回傳所有產品。

export const PRODUCTS = [
  {
    id: "pd-baiye",
    code: "bazi-baiye",
    reportType: "baiye-natal",
    persona: {
      name: "白夜",
      craft: "八字批命",
      //  ⚠️ 要跟 engines/baiye-natal 的 ROLE 一致 —— 那份是真的餵給 AI 的。
      //  銀髮執扇、似笑非笑。八字講的是「你是什麼材料」——
      //  配一個早就看完你整本命書、卻不急著安慰你的人，最有說服力。
      //  2026-10-14 Kevin 定調：原本寫「從容…語帶三分餘裕」，
      //  少了「慵懶」「神秘」「戲謔」這三味，以這一行為準。
      tone: "慵懶、神秘、看透世事。說話帶點戲謔，但語氣深沉。",
    },
    glyph: "白夜",
    theme: "ink",
    image: "/images/characters/baiye.jpg",
    imageWide: "/images/characters/baiye-wide.jpg",
    //產品頁一進去就在播的那支影片。放在這裡是給首頁預載用的 ——
    //  它有六、七 MB，在行動網路上要等一下才動得起來，
    //  趁人還在首頁看卡片時先抓下來，點進去就不會先卡一張靜止的畫面。
    //
    //  ⚠️ 只存**檔名**，不存路徑 —— 預載的網址必須跟產品頁實際播的那一個
    //  一字不差（含 utils/video-url 加的版本參數），差一個字元就是兩個
    //  不同的快取項目，預載等於白抓。所以兩邊都走 videoUrl()。
    //  （同一支檔名在 products/bazi-baiye/bazi-baiye-page.js 也有一份，改檔名要兩邊一起改）
    intro: "baiye-1.mp4",
    title: "白夜・八字批命",
    subtitle: "你的八字，我一個字也不替你圓",
    badge: "入門",
    //⚠️ 價格的唯一真相在後端 config/product-plans.js（建單時收的是那一份）。
    //  這裡這個只是目錄上的參考值，前端目前沒有任何地方讀它 ——
    //  但留著就要是對的，不然下一個人會照它去算折扣。
    price: 1680,
    path: "/product/bazi-baiye",
    categories: [],
    inputs: ["birthDate", "birthTime", "gender", "birthPlace"],
    //⚠️ 章節的唯一真相在後端 engines/baiye-natal/chapters.js
    //  （那份同時是給 AI 的產出規格，報告頁走 G-4 /baiye-chapters 拿）。
    //  這裡只列章名當目錄摘要，改文案時以後端那份為準。
    //
    //  原本是七章的舊清單（日主與五行、十神格局…），那是引擎還沒改成
    //  九章之前的版本 —— 跟故事頁賣的九章對不上，等於目錄寫一套、交付另一套。
    sections: [
      "撕開命盤的偽裝吧",
      "連你自己都害怕面對的內心",
      "你在紅塵中的人性博弈",
      "事業這場局 你該怎麼破",
      "你的暴富與破財密碼",
      "你的情劫與執念",
      "你的氣血與壽元密碼",
      "你與原生家庭的因果清算",
      "人生大局 這輩子你幾時翻身",
    ],
  },

  {
    id: "pd-jingyue",
    code: "ziwei-jingyue",
    reportType: "jingyue-natal",
    persona: {
      name: "鏡月",
      craft: "紫微斗數",
      //  ⚠️ 要跟 engines/ziwei-jingyue 的 ROLE 一致 —— 那份是真的餵給 AI 的。
      //  （那支引擎目前只有排盤，prompt 還沒寫；寫的時候以這一行為準。）
      //  也是劇情頁台詞的基準：ziwei-jingyue-page 的 SCENES 照這個語氣寫。
      tone: "溫婉、空靈、超脫。語氣輕柔，彷彿聲音是從星空中傳來。",
    },
    glyph: "鏡月",
    theme: "violet",
    image: "/images/characters/jingyue.jpg",
    imageWide: "/images/characters/jingyue-wide.jpg",
    title: "鏡月・紫微斗數",
    subtitle: "人生十二格，一格一格照給你看",
    badge: "旗艦",
    //  跟白夜同價：兩支都是九章二十七節、約 4.9 萬字。
    //  ⚠️ 這個數字只是顯示用，唯一真相在後端 config/product-plans.js
    //  的 jingyue.amount —— 結帳一律用 productID 去那邊查。
    price: 1680,
    path: "/product/ziwei-jingyue",
    categories: [],
    //紫微非有時辰不可，缺了排不出命宮 —— 表單要擋，不能讓人付了錢才發現
    inputs: ["birthDate", "birthTime", "gender"],
    sections: [
      "命宮主星",
      "十二宮總覽",
      "四化飛星",
      "大限與流年",
      "格局吉凶",
      "身宮與晚年",
    ],
  },

  {
    id: "pd-feihong",
    code: "match-feihong",
    reportType: "feihong-natal",
    persona: {
      name: "緋紅",
      craft: "八字姻緣",
      //  ⚠️ 引擎還沒做。做的時候 ROLE 要跟這一行一致（同白夜與鏡月的規矩）。
      //  2026-10-14 Kevin 定調。原本寫「直白、辛辣，敢講難聽的真話」——
      //  那是另一種人：辛辣是把話說重，她是把話說得讓你心裡發癢。
      tone: "妖媚、慵懶，帶點哀怨與通透。語調輕挑，擅長撥弄心弦。",
    },
    glyph: "緋紅",
    theme: "rose",
    image: "/images/characters/feihong.jpg",
    imageWide: "/images/characters/feihong-wide.jpg",
    //  ⚠️ 叫「八字姻緣」不是「愛情合盤」。後端的品名隨故事線變
    //  （姻緣／合盤／合婚，見 config/product-plans 的 labelByLine），
    //  而目錄是在問診之前就看到的 —— 這時候還不知道他走哪一條，
    //  只能用最中性的那一個。
    //
    //  用「合盤」的後果：單身線根本沒有第二張盤，他在首頁看到「愛情合盤」、
    //  付完款的發票與通知信卻寫「八字姻緣」—— 那是會被質疑貨不對版的。
    title: "緋紅・八字姻緣",
    subtitle: "牽在你們之間的那條線，是什麼顏色",
    badge: "話題",
    price: 699,
    path: "/product/match-feihong",
    categories: ["love", "match"],
    //要兩個人的生辰 —— 天生具備社群傳播力，使用者得去問對方要生日
    inputs: [
      "birthDate",
      "birthTime",
      "gender",
      "partnerBirth",
      "relationStatus",
    ],
    sections: [
      "兩人本質",
      "吸引力從哪來",
      "衝突模式",
      "關係走勢",
      "關鍵時間點",
      "給你的建議",
    ],
  },

  {
    id: "pd-fuyaozi",
    code: "liuyao-fuyaozi",
    reportType: "wenwang-hexagram",
    persona: {
      name: "伏爻子",
      craft: "文王聖卦",
      //  ⚠️ 要跟 engines/wenwang-hexagram 的 ROLE 一致 —— 那份是真的餵給
      //  AI 的。原本這裡寫「惜字如金，絕不延伸」，但斷語要寫出卦象、爻辭
      //  再給回應（500-800 字），兩份設定是相反的（Kevin 2026-10-08 定調）。
      tone: "老者，慈祥、睿智。說話玄機暗藏，點到為止，留一分讓你自己去想。",
    },
    glyph: "伏爻",
    theme: "gold",
    image: "/images/characters/fuyaozi.jpg",
    imageWide: "/images/characters/fuyaozi-wide.jpg",
    title: "伏爻子・文王聖卦",
    //  「一事一卦」是他自己的規矩（見問卦頁的禁忌：一事一卦，不可反覆問卦）。
    //  「成與不成」直接取自斷卦引擎要求的結論形式
    //  （wenwang-hexagram-engine：「先給結論：會或不會、該或不該、成或不成」）。
    //
    //  ⚠️ 不要寫成「卦不說滿，剩下的你自己想」那一類。
    //  他的 tone 裡那句「點到為止，留一分讓你自己去想」講的是**說話方式**
    //  （不恐嚇、不替人下決定），不是少給東西 —— 寫成「不說滿」會讓人想
    //  「那我花錢問你幹嘛」，而且跟他實際交付的三段斷語相反。
    subtitle: "一事一卦，成與不成我直說",
    badge: "隨問隨答",
    //單價最低、回購最高。使用者一有事就想再問一次。
    //  ⚠️ 這個數字要跟後端 config/product-plans 的 gua-1 一致 ——
    //  它是目錄卡片上顯示的「從多少起」，而實際收費一律由後端的方案表決定。
    //  2026-10-07 從 199 改成 129（爬過同業之後重定，理由寫在後端那張表）。
    price: 129,
    //—— 直接進問卦聊天室，不走產品介紹頁 ——
    //
    //  伏爻子沒有「介紹頁 → 問診 → 故事頁 → 結帳」那一條（那是白夜的動線）。
    //  他的商品就是一次問答，先看介紹再按一次進去只是多一道門。
    //  所以首頁輪播、排行、搜尋、分類點下去，跟按底部的「問卦」頁籤一樣。
    //
    //  ⚠️ 原本是 /product/liuyao-fuyaozi，但 App.js 裡**沒有**那個 route，
    //  也沒有 catch-all —— 點下去是一片白頁。
    //
    //  path 是全站共用的導向目標（hero-carousel / rank-list / review-card /
    //  category-page / search-content / home-content 都讀它），改這一處就全到位。
    path: "/ask",
    categories: [],
    //不需要生辰 —— 問的是事不是人。這也讓它成為五支裡門檻最低的一支
    inputs: ["question", "castMethod"],
    sections: ["卦象", "用神與世應", "斷語", "應期", "宜忌"],
  },

  {
    id: "pd-panguan",
    code: "liunian-panguan",
    reportType: "liunian-annual",
    persona: {
      name: "判官",
      craft: "流年運勢",
      //閻異閣的「閻」是閻羅，判官是座下執生死簿的那位。
      //他不批命，他翻開簿子唸出今年記了你什麼 —— 宣讀的語氣正好對應
      //流年報告該有的形狀：逐月條列、不解釋、不商量。
      tone: "宣讀判詞，條列分明，不容辯駁，不作安慰。",
    },
    glyph: "判官",
    theme: "crimson",
    image: "/images/characters/panguan.jpg",
    imageWide: "/images/characters/panguan-wide.jpg",
    title: "判官・流年之書",
    //  他的 tone 是「宣讀判詞、不容辯駁」—— 他不問你，他念給你聽。
    //  原本「今年，簿上記了你什麼」意象對（簿），但語氣是詢問，正好相反。
    //  「一條一條」接「條列分明」，「念」接「宣讀判詞」。
    subtitle: "簿上記的，我一條一條念",
    badge: "年度",
    price: 599,
    path: "/product/liunian-panguan",
    categories: [],
    //year 讓使用者選要查哪一年 —— 這是五支裡唯一每年都能再買一次的產品，
    //年底時「查明年」的需求會自己冒出來
    inputs: ["birthDate", "birthTime", "gender", "year"],
    sections: [
      "本年總斷",
      "流月行事曆",
      "財帛",
      "事業",
      "感情",
      "健康",
      "該避開的月份與日子",
      "宜與忌",
    ],
  },
];

//取某一分類底下的產品。
//  「綜合」回傳全部 —— 它不是一個分類，是「不分類」。
//  查不到的 key 回空陣列，由頁面自己顯示空狀態，不要讓畫面壞掉。
export const getProductsByCategory = (key) => {
  if (key === "general") return PRODUCTS;
  return PRODUCTS.filter((p) => p.categories?.includes(key));
};

//用 code 取單一產品。
//  結帳與報告頁都是拿 order.productCode 回來找設定，集中一支才不會各寫各的 find。
export const getProduct = (code) =>
  PRODUCTS.find((p) => p.code === code) || null;

//—— 後端方案代號 → 前端產品代號 ——
//
//  ⚠️ **兩邊的代號不一樣，而且從來沒一樣過。**
//  後端 config/product-plans.js 的 id 是 baiye / jingyue / feihong，
//  這裡的 code 是 bazi-baiye / ziwei-jingyue / match-feihong。
//  訂單與評價存的是**後端那一個**（order.productID），所以任何「拿訂單的
//  productID 回來查前端產品」的地方都要先過這張表 ——
//  直接 getProduct(order.productID) 一律回 null，而 null 不會噴錯，
//  只會讓圖、主色、連結默默變成空的（評價卡的連結會變成 "#"）。
//
//  （my-report-page 踩過同一類的坑，那邊是 reportType 對不上。）
//
//  券類的方案代號不只一個（gua-1/6/10 是同一支產品的三種包數），
//  所以是多對一。新增方案時要回來補一行 —— 這張表不會自己長。
const CODE_BY_PRODUCT_ID = {
  baiye: "bazi-baiye",
  jingyue: "ziwei-jingyue",
  feihong: "match-feihong",
  "gua-1": "liuyao-fuyaozi",
  "gua-6": "liuyao-fuyaozi",
  "gua-10": "liuyao-fuyaozi",
  //  提問券是白夜的功能，不是獨立產品
  "ask-1": "bazi-baiye",
  "ask-6": "bazi-baiye",
  "ask-12": "bazi-baiye",
};

//  查不到就回 null，讓呼叫端自己決定要不要掛那條連結 ——
//  回一個「預設產品」會讓使用者點到不相干的頁面，比沒有連結糟。
export const getProductByProductID = (productID) =>
  getProduct(CODE_BY_PRODUCT_ID[productID] || "");

//—— 給 Meta 用：方案代號 → 產品代號 ——
//
//  送給 Pixel 的 content_ids 一律過這支。漏斗前半段拿得到的是網址
//  （也就是 code），後半段拿得到的是方案代號（baiye / ask-6）——
//  不統一的話 Meta 會當成兩個不相干的內容，漏斗接不起來。
//
//  後端有一份對應的 config/product-plans.js 的 pixelCode，兩邊的值必須一樣。
//  （CAPI 在伺服器上跑，拿不到這支。）
//
//  查不到時回 productID 本身 —— 代號不統一總比送一個空字串好，
//  空的 content_ids 會讓那筆事件在報表上變成無主的。
export const pixelCodeOf = (productID) =>
  CODE_BY_PRODUCT_ID[productID] || productID || "";
